<template>
  <div class="container-performance">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" />
          {{ $t('lang.dl.hostPerformance') }}
        </template>
      </van-nav-bar>
    </div>

    <div class="policy-main right-read" @click.stop="showMonthTips = false">
      <div class="search-block">
        <input v-model="hostessId" maxlength="30" placeholder="Hostess ID" />
        <div></div>
        <img src="./images/search.png" alt="" @click.self="handleSearch" />
      </div>

      <div class="switch-tab">
        <!-- 月 -->
        <!-- prettier-ignore -->
        <div class="tab" :class="{ actTab: tab == 0 }" @click="changeTab(0)">
          <span class="tab-name">{{ $t('lang.commonM.k388') }}</span>
          <div class="month-tip-block">
            <img class="tips" src="@/assets/packageAssets/common/tips01.png" @click.stop="showMonthTips = !showMonthTips" />

            <div v-if="tab == 0 && showMonthTips" class="bubble-tips">
              <div class="bubble-content">
                <p>{{ $t('lang.commonM.k391') }}</p>
                <div class="bubble-tran"></div>
              </div>
            </div>
          </div>
          <span class="tab-bar" v-if="tab == 0"></span>
        </div>
        <!-- 周 -->
        <div class="tab" :class="{ actTab: tab == 1 }" @click="changeTab(1)">
          <span class="tab-name">{{ $t('lang.dl.weekly') }}</span>
          <span class="tab-bar" v-if="tab == 1"></span>
        </div>
        <!-- 日 -->
        <div class="tab" :class="{ actTab: tab == 2 }" @click="changeTab(2)">
          <span class="tab-name">{{ $t('lang.dl.daily') }}</span>
          <span class="tab-bar" v-if="tab == 2"></span>
        </div>
      </div>

      <!-- 月内容 -->
      <div v-if="tab == 0" class="tab-content">
        <div class="total">
          <!-- Total:0 -->
          <!-- prettier-ignore -->
          <div class="total-num">
            {{ $t('lang.dl.total') }} <img :src="getMatchImg('beans')" alt="" /><i>{{ weekData.weekIncome }}</i>
          </div>
          <!-- prettier-ignore -->
          <div class="chooseWeek">
            <!-- 下拉框 -->
            <div class="btn" @click="selectMonthShow">
              {{ monthSelectedTxt }}<img :class="{ activeImg: monthShowSelect }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
            <!-- 下拉选项 -->
            <div class="select" v-if="monthShowSelect">
              <div @click="selectMonth(1)">{{ $t('lang.commonM.k389') }}</div>
              <div @click="selectMonth(2)">{{ $t('lang.commonM.k390') }}</div>
            </div>
          </div>
        </div>
        <TableList :data="monthData.hostIncomes"></TableList>
      </div>

      <!-- 周内容 -->
      <div v-if="tab == 1" class="tab-content">
        <div class="total">
          <!-- Total:0 -->
          <!-- prettier-ignore -->
          <div class="total-num">
            {{ $t('lang.dl.total') }} <img :src="getMatchImg('beans')" alt="" /><i>{{ weekData.weekIncome }}</i>
          </div>
          <!-- prettier-ignore -->
          <div class="chooseWeek">
            <!-- 下拉框 -->
            <div class="btn" @click="selectWeekShow">
              {{ weekSelectedTxt }}<img :class="{ activeImg: weekShowSelect }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
            <!-- 下拉选项 -->
            <div class="select" v-if="weekShowSelect">
              <div @click="selectWeek(1)">{{ $t('lang.dl.thisWeek') }}</div>
              <div @click="selectWeek(2)">{{ $t('lang.host.lastWeek') }}</div>
            </div>
          </div>
        </div>
        <TableList :data="weekData.hostIncomes"></TableList>
      </div>

      <!-- 日内容 -->
      <div v-if="tab == 2" class="tab-content">
        <div class="total">
          <!-- prettier-ignore -->
          <div class="total-num">
            {{ $t('lang.dl.total') }} <img :src="getMatchImg('beans')" alt="" /><i>{{ dayData.dailySumIncome }}</i>
          </div>
          <!-- prettier-ignore -->
          <div class="chooseWeek">
            <!-- 下拉框 -->
            <div class="btn" @click="selectDay">
              {{ handleMoment(chooseTime, 'YYYY-MM-DD') }}
              <img :class="{ activeImg: showPop }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
          </div>
        </div>
        <TableList :data="dayData.hostIncomes"></TableList>
      </div>
    </div>

    <CTimeDay :showPop="showPop" :minDate="minDate" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import { apiFetchMonthIncome, apiFetchWeekIncome, apiFetchDailyIncome } from '@/api/imee'

import TableList from './components/TableList.vue'
import CTimeDay from '@/components/CTimeDay'
import moment from 'moment'

export default {
  components: { TableList, CTimeDay },
  data() {
    return {
      tab: 1,

      // 查询
      hostessId: '',
      limit: 500,
      offset: 0,

      showMonthTips: false,

      // 月选择
      monthShowSelect: false,
      monthSelectedTxt: this.$t('lang.commonM.k389'),
      monthSelected: 1,

      // 周选择
      weekShowSelect: false,
      weekSelectedTxt: this.$t('lang.dl.thisWeek'),
      weekSelected: 1,

      // 日选择
      chooseTime: new Date(),
      showPop: false,
      minDate: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),

      // 结果
      monthData: {},
      weekData: {},
      dayData: {}
    }
  },
  methods: {
    handleSearch() {
      // 月
      if (this.tab == 0) {
        this.fetchMonthIncome(this.monthSelected)
        return
      }

      // 周
      if (this.tab == 1) {
        this.fetchWeekIncome(this.weekSelected)
        return
      }

      // 日
      if (this.tab == 2) {
        this.fetchDailyIncome(this.chooseTime)
        return
      }
    },

    // 获得月收益列表  1-本月 2-上月
    fetchMonthIncome(type) {
      apiFetchMonthIncome({
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        timeType: type
      }).then((res) => {
        if (res) {
          this.monthData = res
        }
      })
    },

    // 获得周收益列表  1-本周 2-上周
    fetchWeekIncome(type) {
      let params = {
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        timeType: type
      }
      apiFetchWeekIncome(params).then((res) => {
        if (res) {
          this.weekData = res
        }
      })
    },

    // 获得日收益列表
    fetchDailyIncome(val) {
      let params = {
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        agentDay: moment(val).format('yyyy-MM-DD')
      }
      apiFetchDailyIncome(params).then((res) => {
        if (res) {
          this.dayData = res
        }
      })
    },

    // tab选中
    changeTab(tabIndex) {
      this.tab = tabIndex

      this.monthShowSelect = false
      this.weekShowSelect = false

      // 月
      if (tabIndex == 0) {
        this.fetchMonthIncome(this.monthSelected)
        return
      }

      // 周
      if (tabIndex == 1) {
        this.fetchWeekIncome(this.weekSelected)
        return
      }

      // 日
      if (tabIndex == 2) {
        this.fetchDailyIncome(this.chooseTime)
        return
      }
    },

    // 月选择
    selectMonthShow() {
      this.monthShowSelect = !this.monthShowSelect
    },
    selectMonth(type) {
      switch (type) {
        case 1:
          this.monthSelectedTxt = this.$t('lang.commonM.k389')
          this.monthSelected = 1
          break
        case 2:
          this.monthSelectedTxt = this.$t('lang.commonM.k390')
          this.monthSelected = 2
          break
      }
      this.fetchMonthIncome(type)
      this.monthShowSelect = false
    },

    // 周选择
    selectWeekShow() {
      this.weekShowSelect = !this.weekShowSelect
    },
    // 周选择
    selectWeek(type) {
      switch (type) {
        case 1:
          this.weekSelectedTxt = this.$t('lang.dl.thisWeek')
          this.weekSelected = 1
          break
        case 2:
          this.weekSelectedTxt = this.$t('lang.host.lastWeek')
          this.weekSelected = 2
          break
      }
      this.fetchWeekIncome(type)
      this.weekShowSelect = false
    },

    // 日选择
    selectDay() {
      this.weekShowSelect = !this.weekShowSelect
      this.showPop = true
    },
    // 日选择
    handleCurrentDate(val) {
      this.chooseTime = val
      this.fetchDailyIncome(this.chooseTime)
    },
    // 关闭弹框
    closePop() {
      this.showPop = false
    }
  },
  created() {
    this.fetchWeekIncome(1)
  },
  mounted() {
    window.document.body.scrollTo({ top: 0 })
  }
}
</script>
<style lang="scss" scoped>
// 导航栏
::v-deep .van-nav-bar__left {
  font-family: Inter;
  font-weight: bold;
  font-size: 17px;
  color: #000;
}

// 导航栏
.custom-nav-block {
  background-color: #ffffff;
}

// 内容
.container-performance {
  width: 100%;
  min-height: 812px;
  background: #fff;
  .policy-main {
    .search-block {
      width: 335px;
      margin: 6px auto 0;
      padding: 6px 4px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      background: var(--Background-Bg1, #f9f9fb);

      input {
        height: 20px;
        flex: 1;
        font-size: 16px;
        background: var(--Background-Bg1, #f9f9fb);
        text-indent: 10px;
        &::placeholder {
          font-family: HindMadurai;
          font-weight: 400;
          font-size: 13px;
          color: #cdcdd4;
        }
      }
      div {
        width: 1px;
        height: 18px;
        margin: 0 4px;
        border-radius: 2px;
        background: var(--Card-Card-1, #eeeef1);
      }
      img {
        box-sizing: content-box;
        width: 20px;
        height: 20px;
        border: 4px solid transparent;
        margin: 0 4px;
      }
    }

    .switch-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 34px;
      margin: 16px auto 0;
      padding: 0 16px;
      .tab {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 6px;
        position: relative;

        .tab-name {
          line-height: 24px;
          font-family: Inter;
          font-weight: 400;
          font-size: 16px;
          font-style: normal;
          color: #999999;
        }

        .month-tip-block {
          width: 24px;
          height: 24px;
          text-align: left;
          position: relative;
          overflow: visible;
          .tips {
            box-sizing: content-box;
            width: 16px;
            height: 16px;
            border: 4px solid transparent;
          }

          .bubble-tips {
            position: absolute;
            top: 0;
            left: -8px;
            z-index: 99;
            transform: translateY(-115%);
            width: 200px;
            border-radius: 6px;
            background-color: #333333;
            overflow: visible;
            .bubble-content {
              width: 100%;
              padding: 5px 10px;
              position: relative;
              overflow: visible;
              p {
                font-family: RobotoFlex;
                font-size: 12px;
                color: #e6e5e7;
                line-height: 14px;
              }
              .bubble-tran {
                position: absolute;
                left: 13px;
                bottom: -5px;
                width: 0;
                height: 0;
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
                border-top: 8px solid #333333;
              }
            }
          }
        }
        .tab-bar {
          width: 26px;
          height: 4px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          border-radius: 2px;
          background: #000000;
        }
      }
      .actTab {
        color: #333333;
        background: #fff;
      }
    }

    .tab-content {
      margin-top: 16px;
      .total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        padding: 0 16px;
        background: #f9f9fb;
      }
      .total-num {
        display: flex;
        align-items: center;

        font-family: Inter;
        font-weight: 400;
        font-size: 17px;
        color: #999999;
        line-height: 20px;
        font-style: normal;
        > img {
          width: 14px;
          height: 14px;
          margin: 0 2px;
        }
        i {
          color: #fd56b6;
        }
      }
      .chooseWeek {
        position: relative;
        font-size: 14px;
        .btn {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 25px;
          height: 30px;
          background: #fff;
          border-radius: 6px;
          > img {
            position: absolute;
            right: 4px;
            width: 16px;
          }
          .activeImg {
            rotate: 180deg;
          }
        }
        .select {
          position: absolute;
          z-index: 100;
          width: 107px;
          margin-top: 8px;
          background: #f9f9fb;
          border-radius: 6px;
          color: #666666;
          font-size: 14px;
          box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
          > div {
            height: 30px;
            margin: 5px 0;
            line-height: 30px;
            text-align: center;
          }
        }
      }
    }
  }
}

html[lang='ar'] {
  .container-performance .policy-main .switch-tab .tab .month-tip-block .bubble-tips {
    left: unset;
    right: -8px;
  }
  .container-performance .policy-main .switch-tab .tab .month-tip-block .bubble-tips .bubble-content .bubble-tran {
    left: unset;
    right: 13px;
  }
}
</style>
